import { useLoginContext } from "../../../App";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";
import { useContentContext } from "../../layout/Layout";
import { showNotification } from "../../b2b-common/Notification";
import { useQuery } from "@tanstack/react-query";
import { fetchPlanData } from "../../../services/b2b-plans-apiService";
import { useState } from "react";

const useGettingPlanData = (planUUID, includeImages = false) => {
    const { loginData } = useLoginContext();
    const { t } = useB2BTranslation('b2b-plans');
    const { setNotification } = useContentContext();

    const [isSearching, setIsSearching] = useState(false);

    const gettingPlanData = async (plannUUID) => {
        const { accessToken } = loginData;
        try {
            setIsSearching(true);
            const response = await fetchPlanData(accessToken, planUUID, includeImages);
            return response;
        } catch (error) {
            console.error('Error fetching plan data:', error);
            showNotification(setNotification, t('Error fetching plan data: ') + error.message, 'error', 5000);
        } finally {
            setIsSearching(false);
        }
    }

    const { data: planData } = useQuery({
        queryKey: ['planData', planUUID],
        queryFn: () => gettingPlanData(planUUID),
    });

    return { planData, isSearching };

}

export default useGettingPlanData;